

























import CandleImage from "./CandleImage.vue";
import emojiRegex from "emoji-regex";
import { Component, Prop, Vue } from "vue-property-decorator";
import Candle from "@/models/candle";
import { AppLanguage } from "@/language";
import languageStore from "@/store/modules/language";

@Component({
  components: {
    CandleImage,
  },
  watch: {
    newCandleName: function () {
      const instance = this as CreateCandle;
      instance.updateInputValidation();
    },
  },
})
export default class CreateCandle extends Vue {
  private static readonly validNameRegex = /^[^(\d|(\r?\n|\r))]+$/;
  private static readonly invalidEmogiRegex = emojiRegex();

  private isActive = false;
  private validationMessage = "";

  private newCandle: Candle = {
    name: "",
  };

  get language() {
    return languageStore.language;
  }

  get candleSize() {
    return this.isActive ? "big" : "normal";
  }

  get newCandleName() {
    return this.newCandle.name;
  }

  get headerText(): string {
    switch (this.language) {
      case "es":
        return 'Enciende una vela';
      case "en":
      default:
        return "Light A Candle";
    }
  }

  get promptText(): string {
    switch (this.language) {
      case "es":
        return 'Comparte un nombre para recordar a los que han fallecido.';
      case "en":
      default:
        return "Share a name to remember those who have passed.";
    }
  }

  get dialogTextPre(): string {
    switch (this.language) {
      case "es":
        return 'Enciende una vela por';
      case "en":
      default:
        return "Light A Candle for";
    }
  }

  handleClick() {
    if (!this.isActive) {
      this.isActive = true;
      this.$emit("active", true);
    } else if (this.isActive && this.newCandle.name) {
      this.confirmLightCandle();
    } else {
      this.isActive = false;
      this.$emit("active", false);
    }
  }

  handleEnter() {
    if (this.isActive && this.newCandle.name) {
      this.confirmLightCandle();
    }
  }

  confirmLightCandle() {
    if (!this.validationMessage) {

      const title = `${this.headerText}?`
      const text = `${this.dialogTextPre} ${this.newCandleName}?`;
      const cancelTitle = (this.language === 'es') ? 'Cancel' : 'Cancel'; // TODO
      const lightTitle = (this.language === 'es') ? 'Enciende' : 'Light';

      this.$modal.show("dialog", {
        name: "dialog",
        title,
        text,
        buttons: [
          {
            title: cancelTitle,
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: lightTitle,
            handler: () => {
              this.$modal.hide("dialog");
              this.lightCandle();
            },
          },
        ],
      });
    }
  }

  lightCandle() {
    this.$emit("light-candle", this.newCandle);
  }

  updateInputValidation() {
    if (
      !CreateCandle.validNameRegex.test(this.newCandleName) ||
      CreateCandle.invalidEmogiRegex.test(this.newCandleName)
    ) {
      // TODO: Spanish
      this.validationMessage = "The input name is invalid.";
    } else {
      this.validationMessage = "";
    }
  }
}
